const responseConcilitionBuy = {

    "payload": [
        {
            "isReconcilable": true,
            "transactionId": 1,
            "date": "4/06/2003",
            "totalValue": "3000000",
            "companyDto": {
                "name": "IKEA",
                "identificationNumber": "1.122.334.455",
            },
            "paymentMethodDto": {
                "paymentMethodId": 1,
                "paymentMethodName": "PSE"
            },
            "transactionStateDto":
            {
                "transactionStateId": 1,
                "stateName": "Pendiente",
                "description": "Pago pendiente"
            },
            "link": 'https://ibliss-files-dev.s3.amazonaws.com/product-pizarra/cajapadre_aasasas.pdf'
        },
        {
            "isReconcilable": false,
            "transactionId": 2,
            "date": "6/07/2014",
            "totalValue": "3000000",
            "companyDto": {
                "name": "Redeban",
                "identificationNumber": "1.222.444.455",
            },
            "paymentMethodDto": {
                "paymentMethodId": 2,
                "paymentMethodName": "Transferencia"
            },
            "transactionStateDto":
            {
                "transactionStateId": 2,
                "stateName": "Rechazado",
                "description": "Pago cancelado",
            },
            "link": 'https://ibliss-files-dev.s3.amazonaws.com/product-pizarra/cajapadre_aasasas.pdf',
            "observationMessage": "Se rechazo porque falto $100.000"
        },
        {
            "isReconcilable": false,
            "transactionId": 3,
            "date": "5/11/2018",
            "totalValue": "4000000",
            "companyDto": {
                "name": "Redeban",
                "identificationNumber": "1.222.444.455",
            },
            "paymentMethodDto": {
                "paymentMethodId": 2,
                "paymentMethodName": "Transferencia"
            },
            "transactionStateDto":
            {
                "transactionStateId": 3,
                "stateName": "Devolución",
                "description": "Pago cancelado",
            },
            "link": 'https://ibliss-files-dev.s3.amazonaws.com/product-pizarra/cajapadre_aasasas.pdf',
            "observationMessage": "Se devolvio debido a que no llego el dinero"
        },
        {
            "isReconcilable": true,
            "transactionId": 4,
            "date": "8/10/2020",
            "totalValue": "4000000",
            "companyDto": {
                "name": "Redeban",
                "identificationNumber": "1.222.444.455",
            },
            "paymentMethodDto": {
                "paymentMethodId": 2,
                "paymentMethodName": "Transferencia"
            },
            "transactionStateDto":
            {
                "transactionStateId": 4,
                "stateName": "Verificado",
                "description": "Pago cancelado",
            },
            "link": 'https://ibliss-files-dev.s3.amazonaws.com/product-pizarra/cajapadre_aasasas.pdf'
        }
    ]

};

const responseChagenState = {

    "payload": [
        {
            "transactionStateId": 1,
            "stateName": "Pendiente",
            "description": "Pago pendiente"
        },
        {
            "transactionStateId": 2,
            "stateName": "Rechazado",
            "description": "Pago cancelado"
        },
        {
            "transactionStateId": 3,
            "stateName": "Devolución",
            "description": "Pago exitoso"
        },
        {
            "transactionStateId": 4,
            "stateName": "Verificado",
            "description": "Pago revisado"
        },

    ]
};

const responsepost = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'El cambio de estado fue actualizado exitosamente'
        }
    },
};

export const service = {

    getPurchaseReconciliation: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseConcilitionBuy }), 1000);
    }),

    getTypeChangeState: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseChagenState }), 1000);
    }),

    postChangeState: () => new Promise(resolve => {
        setTimeout(resolve({ data: responsepost }), 1000);
    }),

}